import { classOptions, makeOptions } from 'modules/equipment';

export const getTrnsactMakeValueFromVinDecoding = (manufacturer: string): string => {
  const trnsactEquipmentMakeOptions = makeOptions.map(o => o.value);
  const equipmentMake =
    trnsactEquipmentMakeOptions.find(make => make.toLowerCase() === manufacturer.toLowerCase()) ||
    trnsactEquipmentMakeOptions.find(make => manufacturer.toLowerCase().includes(make.toLowerCase()));
  return equipmentMake || '';
};

export const getTrnsactClassValueFromVinDecoding = (gvwr: string): string => {
  const trnsactEquipmentClassOption = classOptions.map(o => o.value);
  const equipmentClass = trnsactEquipmentClassOption.find(o => gvwr.toLowerCase().includes(o.toLowerCase()));
  return equipmentClass || '';
};
